<template>
    <div class="detail">
        <div class="nav pr">
            <go-back
              class="pa go-back"
            ></go-back>
            <span
                    class="item fs16 font333 pointer"
                    v-for="(item,index) of computedNavList"
                    :key="index"
                    @click="tabChange(item)"
                    :class="{ on: getActive(item) }"
            >{{item.name}}</span>
        </div>
        <div class="view-outer pc-padding30-mobil-padding20">
            <router-view
              :account-mt-id="+$route.params.mtid"
              :overview-info="overviewInfo"
            ></router-view>
        </div>
    </div>
</template>

<script>
import { setIsMaster } from '@/utils/common'
import { mapGetters } from 'vuex';
  export default {
    name: 'index',
    props: {
      overviewInfo: {
        type: Object,
        default(){
          return {}
        }
      },
    },
    data() {
      let _this = this;
      return {
        navList: [
          {
            name: _this.$t('Overview'),
            routerName: 'mamMasterOverview'
          },
          {
            name: _this.$t('Trading_cycle'),
            routerName: 'mamMasterTradingCycle'
          },
          {
            name: _this.$t('Subscribe_to_my'),
            routerName: 'mamMasterSubscription'
          },

          {
            name: _this.$t('income'),
            routerName: 'mamMasterIncome'
          },
        ],
      };
    },
    watch: {
      overviewInfo:{
        handler(val){
          if(val){
            this.$store.commit('setDetailsIsMaster', this.userInfo.id == val.custId);
          }
        },
        deep: true
      },
    },
    created(){
      // setIsMaster(this);
    },
    mounted() {
      let reouterview = document.getElementById('routerview');
      if(!reouterview) return;
      reouterview.classList.add('no-padding-import');
    },
    beforeDestroy(){
      let reouterview = document.getElementById('routerview');
      if(reouterview){
        reouterview.classList.remove('no-padding-import');
      }
      this.$store.commit('setDetailsIsMaster', true);
    },
    computed: {
      ...mapGetters(['userInfo','detailsIsMaster']),
      computedNavList(){
        if(!this.detailsIsMaster){
          let filterList = this.navList.filter((item,index) => {
            return item.routerName == 'mamMasterOverview';
          });
          return filterList;
        }
        return this.navList;
      }
    },
    methods: {
      tabChange(item){
        this.$router.push({name: item.routerName});
      },
      getActive(item){
        return item.routerName == this.$route.name;
      },
    }
  };
</script>

<style lang="scss" scoped>
.detail {

}

</style>
